import { getConferenceState } from '../../../react/features/base/conference/functions';
import { browser } from '../../../react/features/base/lib-jitsi-meet';
import {
    getLocalJitsiDesktopTrack, getVirtualScreenshareParticipantTrack
} from '../../../react/features/base/tracks/functions';
import { resizeLargeVideo } from '../../../react/features/large-video/actions';
import { getToolboxHeight } from '../../../react/features/toolbox/functions.web';
import VideoLayout from '../../../modules/UI/videolayout/VideoLayout';
import {
    BASE_PARAMS,
    REQUEST_TYPES
} from '../../components/wildix-remote-control/constants';
import Env from '../../modules/Environment';
import executeWisRpc from '../../modules/WIService/helpers/executeWisRpc';
import getWisSocket from '../../modules/WIService/helpers/getWISConnection';

export function getLinkForDownloadService() {
    return Env.isMacintosh() ? BASE_PARAMS.urlDownloadServiceMac : BASE_PARAMS.urlDownloadServiceWin;
}

export function changeHeightSharingForLaunchingUser(isToolboxHeight, { state, dispatch, clientHeight: paramsHeight }) {
    let height = 0;
    let windowHeight = paramsHeight;

    if (!paramsHeight) {
        const { clientHeight } = state['features/base/responsive-ui'];

        windowHeight = clientHeight;
    }

    if (isToolboxHeight) {
        height = windowHeight - getToolboxHeight();
    } else {
        const largeVideoContainer = VideoLayout.getLargeVideo();

        height = undefined;
        largeVideoContainer.preferredHeight = height;
    }

    dispatch(resizeLargeVideo(null, height));
}

export function prepareDataToSend(object) {
    return JSON.stringify({
        ...object
    });
}

export async function sendDataToWIService(typeMessage, objectMetadata, isNeedId) {
    const rpcCommand = {
        message: typeMessage,
        ...objectMetadata
    };
    const socket = await getWisSocket();

    if (!socket) {
        return;
    }
    executeWisRpc(socket, rpcCommand, isNeedId);
}

export function isScreenSharingPlayingByUserID(state, participantID) {
    const tracks = state['features/base/tracks'];
    const { conference } = getConferenceState(state);

    if (!tracks.length || !conference) {
        return false;
    }
    const baseUserID = participantID ?? conference?.myUserId();
    const { jitsiTrack } = getVirtualScreenshareParticipantTrack(tracks, baseUserID) ?? {};

    return Boolean(jitsiTrack && !jitsiTrack?.isMuted());
}

export function isDialogOpened(state) {
    const { componentProps } = state['features/base/dialog'];

    return componentProps?.CONTROL_DIALOG_REQUEST === REQUEST_TYPES.CONTROL_DIALOG_REQUEST;
}

export function isSharingTabTrack(jitsiTrack) {
    const { deviceId } = jitsiTrack || {};

    return Boolean(deviceId && deviceId.includes(BASE_PARAMS.sharingTabString));
}

export function isSharingTab(state) {
    return isSharingTabTrack(getLocalJitsiDesktopTrack(state)) && isScreenSharingPlayingByUserID(state);
}

export function isFirefoxLocalSharing(state) {
    const { track } = getLocalJitsiDesktopTrack(state) || {};

    return browser.isFirefox() && track;
}

export function isVersionSupportControl(state) {
    const { version: { wiservice } } = state['wildix/features/wiservice'];

    return _compareVersion(BASE_PARAMS.minVersionWiService, wiservice);
}

function _compareVersion(currentVersion, latestVersion) {
    if (currentVersion === latestVersion || !currentVersion || !latestVersion) {
        return true;
    }

    const _currentVersion = currentVersion.split('.');
    const _latestVersion = latestVersion.split('.');

    for (let i = 0; i < _latestVersion.length; i++) {
        if (Number(_latestVersion[i]) > Number(_currentVersion[i])) {
            return true;
        } else if (Number(_latestVersion[i]) < Number(_currentVersion[i])) {
            return false;
        }
    }

    return false;
}

export function toggleVisibilityHeaderContainer(state) {
    const elementContainer = document.querySelector('.details-container');
    const elementWatermark = document.querySelector('.watermark');
    const elementFeedback = document.querySelector('.usabilla_live_button_container');
    const visibility = state ? 'hidden' : 'visible';

    if (elementContainer) {
        elementContainer.style.visibility = visibility;
    }
    if (elementWatermark) {
        elementWatermark.style.visibility = visibility;
    }

    if (elementFeedback) {
        elementFeedback.style.visibility = visibility;
    }

}

export function checkChatInFocus(state) {
    const { isOpen } = state['features/chat'];

    if (!isOpen) {
        return;
    }
    const textAreaChat = document.getElementById('usermsg');

    return document.activeElement === textAreaChat;
}
